<template lang="pug">
  div.layer-select
    ods-button(type="button" @click="showList" :class="{'layer-select__button--active': openList}").layer-select__button
      div
        ods-icon(name="sort-1" size="16")
        ods-icon(name="multiple" size="20")
    div.layer-select__list(:class="{'layer-select__list--opened': openList, 'layer-select__list--closed': !openList}")
      template(v-for = "(slot, name, index) in $slots")
        slot(:name="name")
</template>

<script>
export default {
  name: 'LayersSelect',
  data () {
    return {
      openList: false
    }
  },
  methods: {
    showList () {
      this.openList = !this.openList
    }
  }
}
</script>

<style scoped lang="scss">
  .layer-select {
    position: relative;
    // transform: translate3d(0, 0px, 0);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    box-shadow: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    // transition: box-shadow 0.7s ease;
    &__button {
      border: 0;
      background: none;
      min-width: 81px;
      min-height: 36px;
      border-radius: 0;
      padding: 0;
      background-color: $--color-white;
      padding: 0;
      cursor: pointer;
      color: $--color-blue-dark;
      &:focus {
        outline: none;
      }
      .ods-icon-multiple {
        transform: rotate(90deg);
      }
      .ods-icon-sort-1 {
        transform: rotateZ(0);
        transition: transform .3s;
        margin-right: 8px;
      }
      &--active {
        .ods-icon-sort-1 {
          transform: rotate(-180deg);
          transition: transform .3s;
        }
      }
    }

    &__list {
      top: 100%;
      left: 0;
      padding: 7.4px 13px;
      padding-bottom: 12px;
      position: absolute;
      width: auto;
      background-color: $--color-white;
      box-shadow: 0 2px 8px 0 rgba(0,0,0,0.1);
      z-index: 30;
      &--opened {
        transform: scale3d(1,1,1);
        transform-origin: top;
        opacity: 1;
        z-index: 20;
        height: 100%;
        transition: transform 0.2s ease;
        .ods-button {
          opacity: 1;
          transition: 0.2s ease 0.1s;
          height: auto;
        }
      }
      &--closed {
        transform: scale3d(1,0,1);
        transform-origin: top;
        z-index: 20;
        transition: transform 0.2s ease;
      }
      .ods-button {
        border: 0;
        background: none;
        width: 100%;
        padding: 0;
        margin: 0;
        background-color: transparent;
        padding: 0;
        cursor: pointer;
        &--text {
          text-transform: none;
          color: black;
          text-align: left;
        }
        +.ods-button{
          margin-left: 0;
        }
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/LayersSelect.vue